import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { Store } from "@ngxs/store";

import { PermitType } from "@ha/data/basic";
import { PermitCreateActions } from "../../../permit-create/states/permit-create.actions";
import { PermitPaths } from "../../../permit-paths";
import { PermitRequest } from "../../../shared/models/permit-request.model";

@Component({
    selector: "pmt-permit-request-list-item",
    templateUrl: "./permit-request-list-item.component.html",
    styleUrls: ["./permit-request-list-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PermitRequestListItemComponent {
    @Input()
    public item!: PermitRequest;

    public permitPaths = PermitPaths;

    constructor(private store: Store) {}

    public onClick(): void {
        this.store.dispatch(
            new PermitCreateActions.CreatePermit(
                true,
                this.item.isDemo,
                PermitType.flammableAtex,
                this.item.hotWorkPermitId,
                undefined,
                undefined,
            ),
        );
    }

    public fullPermitName(item: PermitRequest): string {
        if (item.workplaceContainer == null) {
            return item.workplace;
        } else {
            return item.workplace?.length > 0
                ? item.workplaceContainer + " - " + item.workplace
                : item.workplaceContainer;
        }
    }
}
